import {
  buildPriceSafeFacetNavigationUrl,
  preservePriceUiState,
  shouldReloadFacetBfcachePage,
  shouldReloadFacetHistoryTarget,
  shouldUseFullFacetNavigation,
} from "./cielohuk-facets-recovery-core.js?v=20260727-1";

const FACET_FORM_SELECTOR = "hdt-facet-filters-form[section-id]";
const DIRECT_FILTER_SURFACE_SELECTOR =
  "cielohuk-direct-filter-chips[data-base-collection-url], cielohuk-direct-filter[data-base-collection-url]";
const LOADING_TIMEOUT_MS = 15_000;

function hasDirectFilterSurface() {
  return Boolean(document.querySelector(DIRECT_FILTER_SURFACE_SELECTOR));
}

function getFacetHistoryState() {
  const form = document.querySelector(FACET_FORM_SELECTOR);
  const sectionId = form?.getAttribute("section-id");
  if (!sectionId) return null;

  const url = new URL(window.location.href);
  url.searchParams.delete("section_id");
  return {
    ...(history.state ?? {}),
    FacetUrl: url.toString(),
    section_id: sectionId,
  };
}

function clearStaleFacetLoading() {
  document
    .querySelectorAll(".shopify-section[loading]")
    .forEach((section) => section.removeAttribute("loading"));
  document.documentElement.removeAttribute("scroll-lock");
}

const initialState = getFacetHistoryState();
if (initialState && !history.state?.FacetUrl) {
  history.replaceState(initialState, "", initialState.FacetUrl);
}

let loadingTimeout = null;

document.addEventListener(
  "facet:render",
  (event) => {
    if (!event.detail?.url) return;

    const targetUrl = preservePriceUiState(
      event.detail.url,
      window.location.href,
    );
    event.detail.url = targetUrl;
    if (
      !shouldUseFullFacetNavigation({
        url: targetUrl,
        hasDirectFilterSurface: hasDirectFilterSurface(),
      })
    ) {
      return;
    }

    // Direct-filter pages keep their applied state in the collection path and
    // URL. Kalles' Ajax replacement can leave that URL, the sort label and the
    // product grid on different history entries. A full navigation keeps them
    // atomic and also preserves literal commas for exact-price OR filters.
    event.preventDefault();
    event.stopImmediatePropagation();
    const navigationUrl = buildPriceSafeFacetNavigationUrl(targetUrl);
    if (event.detail?.notPushState) {
      if (
        shouldReloadFacetHistoryTarget({
          navigationUrl,
          currentUrl: window.location.href,
          notPushState: true,
        })
      ) {
        window.location.reload();
      } else {
        window.location.replace(navigationUrl);
      }
    } else {
      window.location.assign(navigationUrl);
    }
  },
  { capture: true },
);

document.addEventListener("theme:loading:doing", () => {
  window.clearTimeout(loadingTimeout);
  loadingTimeout = window.setTimeout(clearStaleFacetLoading, LOADING_TIMEOUT_MS);
});

document.addEventListener("theme:loading:done", () => {
  window.clearTimeout(loadingTimeout);
  loadingTimeout = null;
  queueMicrotask(clearStaleFacetLoading);
});

window.addEventListener("popstate", (event) => {
  if (
    shouldUseFullFacetNavigation({
      url: window.location.href,
      hasDirectFilterSurface: hasDirectFilterSurface(),
    })
  ) {
    event.stopImmediatePropagation();
    window.location.reload();
    return;
  }
  if (!event.state?.FacetUrl && document.querySelector(FACET_FORM_SELECTOR)) {
    window.location.reload();
  }
});

window.addEventListener("pageshow", (event) => {
  if (
    shouldReloadFacetBfcachePage({
      persisted: event.persisted,
      url: window.location.href,
      hasDirectFilterSurface: hasDirectFilterSurface(),
    })
  ) {
    window.location.reload();
  }
});
